import React from "react";

const Education = () => (
  <div className="row education">
    <div className="three columns header-col">
      <h1>
        <span>Education</span>
      </h1>
    </div>

    <div className="nine columns main-col">
      <div className="row item">
        <div className="twelve columns">
          <h3>The Iron Yard</h3>
          <p className="info">
            Certificate in Front-End Engineering
            <span>&bull;</span>
            <em className="date">February 2017</em>
          </p>

          <p>
            Front-End Engineering focuses on creating experiences in web browser that users see and interact with. The discipline covers a broad area, from web design principles to complex JavaScript applications that manage data. The tools used in front-end engineering are ubiquitous--no matter the technology used on the back end, front-enders are responsible for delivering the experience and data to the person using the web application.
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>University of Stirling</h3>
          <p className="info">
            Master of Philosophy - Literature and Languages
            <span>&bull;</span>
            <em className="date">May 2017</em>
          </p>

          <p>
            Thesis: By evaluating theories surrounding the female gaze, flanerie, and tourism, this thesis discusses the representation of female tourists in Paris and Tuscany. Specific films addressed in this thesis: Les Vampires ( Louis Feuillade 1915), Cleo 5 a 7 (Agnes Varda 1962), Funny Face (Stanley Donan 1957), Midnight in Paris (Woody Allen 2011), A Room with a View (James Ivory 1985), and Stealing Beauty (Bernardo Bertolucci 1996).  Specific theorists addressed in this thesis: Charles Baudelaire, Walter Benjamin, Susan Bordo, Giulianna Bruno, Vanessa Schwartz, Mary Ann Doanne, Laura Mulvey, Ann Friedberg and Elizabeth Ezra and Dean MacCannell.
          </p>
          <p>
            Supervisor: Dr Elizabeth Ezra
          </p>
        </div>
      </div>
      <div className="row item">
        <div className="twelve columns">
          <h3>University of Glasgow</h3>
          <p className="info">
            Master of Letters - European Cinema - with Distinction
            <span>&bull;</span>
            <em className="date">May 2009</em>
          </p>

          <p>
            Dissertation: Queering the Femme Fatale; looked at the role of transsexual femme fatales in the films of Pedro Almodovar from the 1980s to Bad Education (2004).
          </p>
          <p>
            Modules in French Spanish, Czech and Polish cinema.
          </p>
        </div>
      </div>
      <div className="row item">
        <div className="twelve columns">
          <h3>Pitzer College - Claremont Consortium</h3>
          <p className="info">
            Bachelors in Media Studies (Film Production) and Theater
            <span>&bull;</span>
            <em className="date">May 2007</em>
          </p>

          <p>
            Senior Media Project: "She's Revamped" a rewriting of Robert Iscove's She's All That (1999) combining video and performance art with gender/sexuality theory and Boal's Theatre of the Oppressed.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default Education;
